(function() { module.exports = window["Next"]["Dialog"]; }());